import {UserService} from './../shared/user.service';
import {Observable} from 'rxjs';
import {Role} from './../shared/role.model';
import {RoleService} from './../shared/role.service';
import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import * as $ from 'jquery';
import {UsuariosListComponent} from './usuarios-list.component';
import {AuthService} from './../services/auth.service';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'pm-add-usuario',
  templateUrl: './add-usuario.component.html',
  styleUrls: ['./add-usuario.component.sass']
})
export class AddUsuarioComponent implements OnInit, OnDestroy, AfterViewInit {
  // registerUserData = {};
  roleSelected: string;
  errorMessage: string = '';

  constructor(
    private parent: UsuariosListComponent,
    private auth: AuthService,
    public service: UserService,
    private roleService: RoleService,
    private router: Router
  ) {
  }

  public pageTitle = 'Agregar Usuario';

  roleList: Observable<Role[]> = this.roleService.allRoles();

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null) {
      form.resetForm();
    }

    this.service.formData = {
      id: 0,
      email: '',
      lastname1: '',
      lastname2: '',
      name: '',
      password: '',
      roleId: '',
      status: '',
      confirmPassword: ''
    };
  }

  ngAfterViewInit() {
    $('a[rel=usuarios]').addClass('selected');
  }

  cancelUsuario(): void {
    this.parent.showUsuarios = true;
    this.parent.showAddUsuario = false;
  }

  addUsuario(form: NgForm): void {
    console.log('addUsuario: form: ', form);
    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    if (form.value.password !== form.value.confirmPassword) {
      this.errorMessage = 'Las contraseñas son diferentes';
      return;
    }

    this.parent.showUsuarios = true;
    this.parent.showAddUsuario = false;
    this.auth.registerUser(form.value).subscribe(
      res => {
        console.log('addUsuario: res: ', res);
        this.router.navigate(['/usuarios']);
      },
      err => console.log('addUsuario: err: ', err)
    );
  }

  ngOnDestroy() {
    $('a[rel=usuarios]').removeClass('selected');
  }
}
